import type { TOC } from '@ember/component/template-only'
import { t } from 'ember-intl'
import { ThStandard } from 'teacher-ui-client/components/th/standard'
import type { ComprehensionProgressOverviewReportData } from 'teacher-ui-client/reporting/ui-scope/rex/dashboard/student/index/route'
import { formatValue } from 'teacher-ui-client/utils/format-value'

interface Args {
  isLoading?: boolean
  overviewData: ComprehensionProgressOverviewReportData['overview']
}

interface Signature {
  Args: Args
  Element: HTMLTableElement
}

export const ComprehensionProgressOverview: TOC<Signature> = <template>
  <table class="border-oceany-blue-150 border-b text-center" ...attributes>
    <thead class="bg-oceany-blue-50">
      <tr class="divide-x divide-white">
        <ThStandard>
          {{t "components.reporting.tables.readingEggspress.dashboardStudent.headers.initialLesson"}}
        </ThStandard>
        <ThStandard>
          {{t "components.reporting.tables.readingEggspress.dashboardStudent.headers.highestLessonCompleted"}}
        </ThStandard>
        <ThStandard>
          {{t "components.reporting.tables.readingEggspress.dashboardStudent.headers.totalLessonsCompleted"}}
        </ThStandard>
        <ThStandard>
          {{t "components.reporting.tables.readingEggspress.dashboardStudent.headers.numberOfQuizzesTaken"}}
        </ThStandard>
        <ThStandard>
          {{t "components.reporting.tables.readingEggspress.dashboardStudent.headers.averageQuizScore"}}
        </ThStandard>
        <ThStandard>
          {{t "components.reporting.tables.readingEggspress.dashboardStudent.headers.totalAttempts"}}
        </ThStandard>
      </tr>
    </thead>
    <tbody class={{if @isLoading "opacity-50"}}>
      <tr>
        <td class="p-3">{{formatValue @overviewData.initial_lesson}}</td>
        <td class="p-3">{{formatValue @overviewData.highest_lesson_completed}}</td>
        <td class="p-3">{{formatValue @overviewData.total_lessons_completed}}</td>
        <td class="p-3">{{formatValue @overviewData.number_of_quizzes_taken}}</td>
        <td class="p-3">{{formatValue @overviewData.average_quiz_score append="%"}}</td>
        <td class="p-3">{{formatValue @overviewData.total_attempts}}</td>
      </tr>
    </tbody>
  </table>
</template>

export default ComprehensionProgressOverview
